import LegerTeacher from "../../../../../components/categories/siakad/lms/leger/HomeTeacher";
export default function Home() {
  
  return (
    <LegerTeacher />
  );
}
